const c = "ids-checkbox-mark-v5150", k = "ids-checkbox-mark--checked-v5150", t = "ids-checkbox-mark--indeterminate-v5150", a = {
  checkboxMark: c,
  checked: k,
  indeterminate: t
}, n = "ids-checkbox-mark-v5150", r = "ids-checkbox-mark--indeterminate-mark-v5150", i = "ids-checkbox-mark--checked-mark-v5150", s = "ids-checkbox-mark--checked-v5150", d = "ids-checkbox-mark--indeterminate-v5150", e = {
  checkboxMark: n,
  indeterminateMark: r,
  checkedMark: i,
  checked: s,
  indeterminate: d
};
Object.assign(a, e);
const o = e;
export {
  o as IressCheckboxStyles
};
